import { render, staticRenderFns } from "./AfterworkList.vue?vue&type=template&id=9a67e726&scoped=true&"
import script from "./AfterworkList.vue?vue&type=script&lang=js&"
export * from "./AfterworkList.vue?vue&type=script&lang=js&"
import style0 from "./AfterworkList.vue?vue&type=style&index=0&id=9a67e726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a67e726",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCol,VRow,VSkeletonLoader,VTimeline,VTimelineItem})
